import Axios from 'axios';
import download from 'downloadjs';

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const backServer = isLocal ? 'http://localhost:3000' : 'https://x.edifly.com';

export const fetchData = async () => {
  let {data} = await Axios.get(`${backServer}/api`);
  return(data);
}

export const downloadFiles = (filename, file_url) => {
  var XML = new XMLHttpRequest();
  XML.open( "GET", file_url , true);
  XML.responseType = "blob";
  XML.onload = e => download(e.target.response, filename);
  XML.send();
}

export const postDownloadedFile = async (props) => {
  return Axios.post(`${backServer}/downloaded_files`, {downloaded_file: props});
}

export const postMessage = async (props) => {
  return Axios.post(`${backServer}/messages`, {message: props});
}

export const postMaintenanceSubscription = async (props) => {
  return Axios.post(`${backServer}/maintenance_subscriptions`, {maintenance_subscription: props});
}
